<template>
  <div v-if="isVisiblePdf" class="modal-overlay">
    <div class="modal-content">
      <h3 class="title">Subir Archivo PDF</h3>
      <form @submit.prevent="submitPdf">
        <div class="form-group">
          <label for="fileName"
            >Nombre del Archivo <span class="text-red"> *</span></label
          >
          <input
            type="text"
            id="fileName"
            v-model="fileName"
            placeholder="Nombre del archivo"
            @input="onFileNameInput($event)"
            @blur="touched.fileName = true"
            maxlength="40"
            required
          />
          <div v-if="touched.file_name && !fileName" class="text-red"></div>
        </div>

        <div class="form-group">
          <label for="category"
            >Categoría <span class="text-red"> *</span></label
          >
          <select
            id="category"
            v-model="category"
            required
            @blur="touched.category = true"
          >
            <option value="" disabled selected>
              Selecciona un tipo de archivo
            </option>
            <option value="NONE">NONE</option>
            <!-- <option value="CDM Overview">CDM Overview</option> -->
            <!-- <option value="Conference Call">Conference Call</option> -->
            <!-- <option value="Presentation">Presentation</option> -->
            <option value="Offering Memorandum">Offering Memorandum</option>
            <option value="Financial Statements">Financial Statements</option>
            <!-- <option value="Ratings">Ratings</option> -->
            <option value="Public ESG">ESG / ASG  </option>
            <option value="Public Operations">Operations / Operaciones</option>
            <option value="Public Location">Public Location</option>
            <option value="Public History">Public History</option>
            <option value="Public About Us">Public About Us</option>
            <option value="General">Inicio / Home</option>
          </select>
          <div v-if="touched.category && !category" class="text-red">
            Debe de seleccionar una categoría
          </div>
        </div>

        <div class="form-group">
          <label for="quarter"
            >Trimestre <span class="text-red"> *</span></label
          >
          <select
            id="quarter"
            v-model="quarter"
            @blur="touched.quarter = true"
            required
          >
            <option value="" disabled selected>Selecciona un trimestre</option>
            <option value="Q1">1</option>
            <option value="Q2">2</option>
            <option value="Q3">3</option>
            <option value="Q4">4</option>
          </select>
          <div v-if="touched.quarter && !quarter" class="text-red">
            Debe de ingresar un trimestre
          </div>
        </div>

        <div class="form-group">
          <label for="year">Año <span class="text-red"> *</span></label>
          <input
            type="number"
            id="year"
            v-model="year"
            placeholder="Año"
            @input="onYearInput($event)"
            @blur="touched.year = true"
            min="2000"
            :max="new Date().getFullYear()"
            required
          />
          <div
            v-if="
              touched.year &&
              (!year || year < 2000 || year > new Date().getFullYear())
            "
            class="text-red"
          >
            Debe ingresar un año válido entre 2000 y
            {{ new Date().getFullYear() }}
          </div>
        </div>

        <div class="form-group">
          <label for="pdf">Archivo PDF <span class="text-red"> *</span></label>
          <input
            type="file"
            id="pdf"
            accept="application/pdf , application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv"
            @change="handleFileChange"
            required
          />
          <div v-if="file" class="text-green">
            Archivo seleccionado: {{ fileName }}
          </div>
        </div>

        <div style="display: flex; justify-content: flex-end">
          <button type="submit" :disabled="!pdfFile || isSubmitting" :class="{'btn-disabled': isSubmitting}" >Subir</button>
          <button type="button" @click="closeModal">Cerrar</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { showErrorToast, showInfoToast, showSuccessToast } from "@/kernel/alerts";
import { uploadFile } from "../services/files-service";
import { getUserEmailByToken } from "@/kernel/utils";

export default {
  props: {
    isVisiblePdf: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      pdfFile: null,
      fileName: "",
      category: "",
      quarter: "",
      year: "",
      file: "",
      touched: {
        fileName: false,
        category: false,
        quarter: false,
        year: false,
        file_name: false,
      },
      isSubmitting: false,
    };
  },
  methods: {
    handleFileChange(event) {
      const file = event.target.files[0];
      if (
        (file && file.type === "application/pdf") ||
        file.type === "application/vnd.ms-excel" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "text/csv"
      ) {
        this.pdfFile = file;
        this.file = file.name;
      } else {
        alert("Solo se permiten archivos PDF.");
        this.pdfFile = null;
        this.file = "";
      }
    },
    onFileNameInput(event) {
      const value = event.target.value;
      // Solo permite letras (incluye tildes), ñ, números, espacios y guiones
      const clean = value.replace(/[^a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ\s-]/g, "");
      this.fileName = clean;
    },
    onYearInput(event) {
      const value = event.target.value.replace(/\D/g, ""); // elimina todo lo que no sea dígito
      this.year = value ? parseInt(value) : "";
    },
    closeModal() {
      this.pdfFile = null;
      this.fileName = "";
      this.$emit("update:visible", false);
    },
    async submitPdf() {
      showInfoToast("Subiendo archivo...");
      this.isSubmitting = true;
      if (!this.pdfFile) {
        showErrorToast("Por favor, selecciona un archivo PDF.");
        this.isSubmitting = false;
        return;
      }

      if (!this.fileName || !this.category || !this.quarter || !this.year) {
        showErrorToast("Por favor, completa todos los campos.");
        return;
      }

      const userEmail = await getUserEmailByToken();

      const formData = new FormData();
      formData.append("file", this.pdfFile);
      formData.append("fileName", this.fileName);
      formData.append("category", this.category);
      formData.append("quarter", this.quarter);
      formData.append("year", this.year);
      formData.append("email", userEmail);

      showSuccessToast("Archivo subido correctamente.");

      try {
        const result = await uploadFile(formData);
        if (result.status === 200) {
          showSuccessToast("Archivo subido correctamente.");
          this.$emit("update:files");
          this.closeModal();
        } else {
          showErrorToast("Error al subir el archivo.");
        }
        this.isSubmitting = false;
      } catch (error) {
        console.error("Error en la solicitud:", error);
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 400px;
  max-width: 100%;
}

.form-group {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
}

input,
select {
  width: 100%;
  padding: 8px;
  margin-top: 5px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

button {
  padding: 10px 15px;
  margin-top: 10px;
  cursor: pointer;
  background-color: orange;
  color: white;
  border: none;
  border-radius: 16px;
}

button[type="submit"]:hover {
  background-color: yellowgreen;
}

button[type="button"] {
  margin-left: 16px;
  background-color: darkgray;
}

button[type="button"]:hover {
  background-color: gray;
}

.title {
  margin-top: 0;
  color: orange;
}

.text-green {
  color: green;
  font-weight: bold;
  margin-top: 8px;
}
.btn-disabled {
  background-color: #ccc !important;
  cursor: not-allowed;
  opacity: 0.6;
}
</style>
